import { FatDoctoUfPercurso } from './../interfaces/fat-docto-uf-percurso';
import { FatDoctoLocalCarga } from './../interfaces/fat-docto-local-carga';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FatDoctoC } from '../interfaces/fat-docto-c';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { FatDoctoI } from '../interfaces/fat-docto-i';
import { FatDoctoIProjection } from '../interfaces/fat-docto-i-projection';
import { FatDoctoRef } from '../interfaces/fat-docto-ref';
import { FatDoctoCCce } from '../interfaces/fat-docto-cc-ce';
import { JwtAuthService } from './auth/jwt-auth.service';

/**
 * Serviço p/ carta de correção
 */
@Injectable({
  providedIn: 'root'
})
export class FatDoctoCCService {


  readonly path = '/lancamento/carta/correcao';


  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {  }
   

  getPageFatDoctoCCce(controle: number, page?: number, size?: number, order?: string, direction?: string) : Observable<PageResult<FatDoctoCCce>>{
    return this.http.get<PageResult<FatDoctoCCce>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${(page??1)<=0?1:page}&size=` +
    `${size}&controle=${controle}&order=${order}&direction=${direction}`);
  }

  getPageSearchFatDoctoCCce(search: string, controle: number, page: number, size: number,  order?: string, direction?: string)  : Observable<PageResult<FatDoctoCCce>>{
    return this.http.get<PageResult<FatDoctoCCce>>(`${this.jwtAuthService.apiUrl + this.path}/page/get?search=${search}&page=${(page??1)<=0?1:page}&size=` +
    `${size}&controle=${controle}&order=${order}&direction=${direction}`);
  }

  createFatDoctoCCce(): Observable<FatDoctoCCce> {
    return this.http.post<FatDoctoCCce>(`${this.jwtAuthService.apiUrl + this.path}`, null)
  }

  saveOrUpdateFatDoctoCCce(doctoRef: FatDoctoCCce): Observable<FatDoctoCCce> {
    return this.http.put<FatDoctoCCce>(`${this.jwtAuthService.apiUrl + this.path}`, doctoRef);
  }

  deleteFatDoctoCCce(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }  
  
  processarCC(controle:number, id: number): Observable<any> {
    console.log(`${this.jwtAuthService.apiUrl + this.path}/processar/${controle}/${id}`);
    return this.http.put<any>(`${this.jwtAuthService.apiUrl + this.path}/processar/${controle}/${id}`, {});
  }  

  pdfCarta(id: number): Observable<any> {
    console.log(`${this.jwtAuthService.apiUrl + this.path}/print/${id}`);
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/print/${id}`, {responseType: 'arraybuffer'})
  }


}
